var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeedingEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Speeding Events",
    role: "img",
    viewBox: "0 0 100 94",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Speeding Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0148,35.7214c7.8668,0,14.2441,6.4073,14.2441,14.311s-6.3773,14.311-14.2441,14.311 s-14.2441-6.4073-14.2441-14.311C35.7789,42.1321,42.1514,35.7297,50.0148,35.7214z M50.0148,56.8393 c3.7459,0,6.7826-3.0509,6.7826-6.8144c0-3.7635-3.0367-6.8144-6.7826-6.8144c-3.7459,0-6.7826,3.0509-6.7826,6.8144 c0,0.0025,0,0.005,0,0.0075C43.2405,53.7913,46.2736,56.8352,50.0148,56.8393z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0189,94c-1.3413,0.0023-2.5805-0.719-3.2458-1.8892c-1.0214-1.7971-0.4001-4.0855,1.3879-5.1127 c13.204-7.5877,21.361-21.6907,21.3848-36.9733c0.0105-5.8643-1.1914-11.6668-3.5294-17.0398 c-0.8231-1.8963,0.0385-4.1038,1.925-4.9327c1.8874-0.827,4.0849,0.0387,4.9098,1.9341 c2.7489,6.3189,4.1616,13.1424,4.1486,20.0384c-0.0278,17.9717-9.619,34.5562-25.1455,43.4802 C74.2954,93.8264,73.6631,93.997,73.0189,94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7945,93.79c-0.6549,0-1.2983-0.1732-1.8654-0.5022C9.5516,84.3485,0.0589,67.8745,0,50.025 C0.111,22.3234,22.5246-0.058,50.097,0.0001c7.0679-0.0162,14.0589,1.4733,20.5118,4.3706 c1.8807,0.843,2.7256,3.0576,1.8878,4.9478c-0.8392,1.8895-3.0434,2.7382-4.9247,1.8966 c-5.4954-2.4774-11.4516-3.7552-17.475-3.7483C26.6455,7.4087,7.5726,26.4336,7.4616,49.995 c0.0515,15.1751,8.1237,29.1802,21.1983,36.7784c1.7817,1.0377,2.3896,3.3294,1.3581,5.1203 C29.3585,93.0595,28.1292,93.7827,26.7945,93.79z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0657,44.8973c-0.9901,0.0018-1.9404-0.392-2.6414-1.0945c-1.4564-1.4637-1.4564-3.8364,0-5.3001 L80.861,13.9513c1.4569-1.4633,3.8185-1.4633,5.2753,0c1.4564,1.4637,1.4564,3.8364,0,5.3001L61.7071,43.8028 C61.0061,44.5053,60.0559,44.899,59.0657,44.8973z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedingEvents);
export default __webpack_public_path__ + "static/media/speeding-events.6722f11f738fd7bd742d24d402373ff4.svg";
export { ForwardRef as ReactComponent };